import AttachFilter from './attachFiter.vue';

export default AttachFilter;



// WEBPACK FOOTER //
// ./src/FcComponents/attachFiter/index.js